import { render, staticRenderFns } from "./StorageView.vue?vue&type=template&id=64f4f41e"
import script from "./StorageView.ts?vue&type=script&lang=ts&external"
export * from "./StorageView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports